import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-dynamic',
    templateUrl: './dynamic.component.html',
    styleUrls: ['./dynamic.component.scss'],
    standalone: false
})
export class DynamicComponent implements OnInit {

  tableName="";
  headerNameHtml = "";
  screenType = ""
  constructor(   private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog,
    private spinner: NgxUiLoaderService,) {

     }

     ngOnInit() {
      this.route.queryParams.subscribe(
        v => {
          this.spinner.start();
          console.log(v);
          this.tableName = v.tableName;
          console.log(this.tableName)
          this.headerNameHtml = v.headerNameHtml;
          this.screenType = v.screenType;
          console.log(this.screenType)
          if(this.screenType == "Static"){
            let url = "/user/Menubar/"+this.tableName;
            console.log(url)
            this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
          this.router.navigate([url]));
          }
          // else if(this.screenType == "Dynamic/Master"){
          //   this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
          //   this.router.navigate(["/user/Menubar/baseComponent"],{queryParams:{screenType:this.screenType,tableName:this.tableName,headerNameHtml:this.headerNameHtml}}));
          // }
          else if(this.screenType == "Dynamic/Transactions"){
            this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/user/Menubar/trnxBaseComponent"],{queryParams:{screenType:this.screenType,tableName:this.tableName,headerNameHtml:this.headerNameHtml}}));
          }
          this.spinner.stop();
  
        }
      )
    }

}
